export class DataStorage {}
//# sourceMappingURL=DataStorage.js.map